
import { axios } from '@/utils/request'

const api = {
  options: '/wyhadminapi/jiaolian/options',
  getApplyList: '/wyhadminapi/jiaolian/shengJlManageList',
  getMemberList: '/wyhadminapi/jiaolian/shengJlList',
  checkShengMemberOK: '/wyhadminapi/jiaolian/checkShengMemberOK',
  shengjlApply: '/wyhadminapi/jiaolian/shengjlApply',
  shengApplyDetail: '/wyhadminapi/jiaolian/shengApplyDetail',
  xlsxImport: '/wyhadminapi/jiaolian/xlsxImport',
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}
export function getApplyList(parameter) {
  return axios({
    url: api.getApplyList,
    method: 'get',
    params: parameter
  })
}
export function getMemberList(parameter) {
  return axios({
    url: api.getMemberList,
    method: 'get',
    params: parameter
  })
}
export function checkShengMemberOK(parameter) {
  return axios({
    url: api.checkShengMemberOK,
    method: 'post',
    data: parameter
  })
}
export function shengjlApply(parameter) {
  return axios({
    url: api.shengjlApply,
    method: 'post',
    data: parameter
  })
}
export function getShengApplyDetail(parameter) {
  return axios({
    url: api.shengApplyDetail,
    method: 'post',
    data: parameter
  })
}

export function xlsxImport(parameter) {
  return axios({
    url: api.xlsxImport,
    method: 'post',
    headers: {
      'Content-Type':'multipart/form-data'
    },
    data: parameter
  })
}
